import { SyncIndicator } from '#components/widgets';
import { useRowContext } from './rowContext';

export function DetailPanelRowSyncIndicator() {
  const { error, loading } = useRowContext();

  return <SyncIndicator dirty={false} loading={loading} error={error} />;
}
